import React from 'react'

export const InfoIcon = () => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="64" height="64" rx="32" fill="#F5F6FA" />
    <path
      d="M32 17.833C40.1002 17.833 46.667 24.3998 46.667 32.5C46.667 40.6002 40.1002 47.167 32 47.167C23.8998 47.167 17.333 40.6002 17.333 32.5C17.333 24.3998 23.8998 17.833 32 17.833ZM32 20.5C25.3726 20.5 20 25.8726 20 32.5C20 39.1274 25.3726 44.5 32 44.5C38.6274 44.5 44 39.1274 44 32.5C44 25.8726 38.6274 20.5 32 20.5ZM32 30.5C32.7363 30.5 33.3328 31.0968 33.333 31.833V37.167C33.3328 37.9032 32.7363 38.5 32 38.5C31.2637 38.5 30.6672 37.9032 30.667 37.167V31.833C30.6672 31.0968 31.2637 30.5 32 30.5ZM32 26.5C32.7363 26.5 33.3328 27.0968 33.333 27.833C33.333 28.5694 32.7364 29.167 32 29.167C31.2636 29.167 30.667 28.5694 30.667 27.833C30.6672 27.0968 31.2637 26.5 32 26.5Z"
      fill="#161616"
    />
  </svg>
)
